import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import TextContainerField from "../../../components/TextContainerField";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById } from "../../../api/Services";
import { useSnackbar } from "../../../context/popup";
import { setCircleLoading } from "../../../components/Loading";

const ViewMotorCategory = () => {
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const params = useParams();
  const [categoryData, setCategoryData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(
            `/reference/motor/key-value-category/${paramId}`
          ).then((res) => {
            setCategoryData(res?.data);
          });
        } catch (error) {
          console.error("Error fetching Data",error);
          showSnackbar(error?.response?.data?.message || "Network Error", "error");
        } finally {
          setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  return (
    <DashboardLayout>
      <Box
        sx={{
          padding: { xs: 2, md: 2 },
          bgcolor: "#f9f9f9",
          minHeight: "100vh",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="left"
          spacing={1}
          mb={2}
        >
          <IconButton onClick={() => navigate("/motor-master/motor-category")}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
            Motor Category Information
          </Typography>
        </Stack>

        {categoryData ? (
          <Grid container spacing={3} sx={{ mx: { xs: 0, md: 2 } }}>
            <Grid xs={12} sm={6} md={4} sx={{ width: "100%" }}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                    {categoryData?.categoryName}
                  </Typography>
                  <TextContainerField
                    label="Category ID"
                    value={categoryData?.id}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Category Code"
                    value={categoryData?.code}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Description"
                    value={categoryData?.description}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Parent Category"
                    value={categoryData?.parentCategory?.categoryName || "N/A"}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Status"
                    value={categoryData?.isActive ? "Active" : "Inactive"}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Created At"
                    value={categoryData?.createdAt}
                    labelStyle={{ fontWeight: "500" }}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Box>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                color: "red",
                fontFamily: "cursive",
              }}
            >
              No Motor Category Data Found
            </Typography>
          </Box>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default ViewMotorCategory;
